$(document).ready(function() {

    ub.constants = {};

    ub.constants.order_actions = {
        SUBMIT_ORDER: 'submit_order',
        SAVE_ORDER: 'save_order'
    };

});